"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const DateFieldSchemaComponent_1 = require("./DateFieldSchemaComponent");
const SchemaColumnConfig_1 = tslib_1.__importDefault(require("../../schema/SchemaColumnConfig"));
class DateFieldSchemaColumnConfig extends SchemaColumnConfig_1.default {
    constructor({ title, titleVisible, mapDataToCell, mapCellToData, headerClassName = new Set(), extraClasses = [] }) {
        super({
            headerStyle: headerClassName,
            heading: title,
            mapDataToTD: mapDataToCell
        });
        this.dateFields = [];
        this.enabled = true;
        this.shouldDisplayWeekDay = false;
        if (titleVisible) {
            if (this.headerStyle instanceof Set) {
                this.headerStyle.add("header-visible");
            }
        }
        const that = this;
        this.renderer = {
            render(ctx, obj) {
                const { row } = ctx;
                const dateField = new DateFieldSchemaComponent_1.DateFieldSchemaComponent({
                    renderingContext: ctx,
                    fieldSizeClass: fmko_ts_widgets_1.FieldSize.MAX,
                    hint: null,
                    label: "Datofelt",
                    labelHidden: true
                });
                dateField.element.classList.add("date-field-schema-component");
                dateField.setValue(obj?.date);
                dateField.addCssClass(...extraClasses);
                dateField.addValueChangeHandler(() => {
                    const data = [...that.grid.getValue()];
                    data[row] = {
                        ...(data[row] ?? {}),
                        ...mapCellToData(data[row], dateField.getValue())
                    };
                    setTimeout(() => that.grid.setValue(data, true));
                });
                that.dateFields.push(dateField);
                ctx.setWidget(dateField);
                dateField.setShouldDisplayWeekDay(that.shouldDisplayWeekDay);
                dateField.setEnabled(that.enabled);
                that.setCellElementEnabled(ctx.currentCell, that.enabled);
            },
            canRender(_o) {
                return true;
            }
        };
    }
    setEnabled(enabled) {
        this.enabled = enabled;
        for (const dateField of this.dateFields) {
            dateField.setEnabled(enabled);
            this.setCellElementEnabled(dateField.element.parentElement, enabled);
        }
    }
    setShouldDisplayWeekDay(shouldDisplayWeekDays) {
        this.shouldDisplayWeekDay = shouldDisplayWeekDays;
        for (const dateField of this.dateFields) {
            dateField.setShouldDisplayWeekDay(this.shouldDisplayWeekDay);
        }
    }
    getDateFields() {
        return this.dateFields;
    }
    clear() {
        this.dateFields = [];
    }
    getData(data) {
        return {
            data: data,
            date: this.mapDataToTD(data)
        };
    }
}
exports.default = DateFieldSchemaColumnConfig;
//# sourceMappingURL=DateFieldSchemaColumnConfig.js.map